import { formatUnits } from 'ethers';
import JSBI from 'jsbi';
import Decimal from 'decimal.js';

export const renderAmountToSignificant = (
  amount: string | bigint | number,
  options: {
    decimals?: number;
    significantDigits?: number;
    rounding?: Decimal.Rounding;
  } = {},
): string => {
  const { decimals = 18, significantDigits = 4, rounding = Decimal.ROUND_DOWN } = options;

  const parsedAmount = JSBI.BigInt(amount.toString());

  if (
    !JSBI.greaterThanOrEqual(parsedAmount, JSBI.BigInt(0)) ||
    !JSBI.lessThanOrEqual(
      parsedAmount,
      JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'),
    )
  ) {
    throw new Error(`${parsedAmount} is not a uint256.`);
  }

  if (!Number.isInteger(significantDigits)) {
    throw new Error(`${significantDigits} is not an integer.`);
  }

  if (significantDigits <= 0) {
    throw new Error(`${significantDigits} is not positive.`);
  }

  const numerator = parsedAmount;
  const denominator = JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(decimals));

  Decimal.set({ precision: significantDigits + 1, rounding });
  const quotient = new Decimal(numerator.toString())
    .div(denominator.toString())
    .toSignificantDigits(significantDigits);
  const significantAmount = quotient.toFixed(quotient.decimalPlaces());
  const showAmount =
    Number(significantAmount) < 1000
      ? significantAmount
      : Number(significantAmount).toLocaleString();
  return showAmount;
};

export const renderBalance = (balance: string | bigint | number, decimal: number = 18) => {
  return Number(formatUnits(balance, decimal)).toLocaleString();
};

export const renderCurrencySigns: Record<string, string> = {
  USD: '$',
  JPY: '¥',
};
